import { Component } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { AppConstants_settings } from '../../../core/AppConstants_Appsettings.enum';
import { NotificationService } from '../../../core/services/notification.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { IndexedDbService } from '../../../core/services/indexed-dbservice.service';
import { LangPipe } from '../../pipes/lang.pipe';

var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-dashboard-footer',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, LangPipe],
  templateUrl: './dashboard-footer.component.html',
})
export class DashboardFooterComponent {
  NewsLetterForm!: FormGroup;
  loading: boolean = false;
  agencyLogoUrl: any;
  constructor(
    private api: ApiService,
    private notification: NotificationService,
    private router: Router,
    private dbService: IndexedDbService,
  ) {}

  ngOnInit(): void {
    this.getLogoData();
    this.NewsLetterForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(emailRegex),
      ]),
    });
  }

  subscribe() {
    if (this.NewsLetterForm.invalid) {
      this.notification.error('Please enter valid email');
      return;
    }
    this.loading = true;
    this.api
      .newsLetter({
        email: this.NewsLetterForm.value.email,
      })
      .subscribe({
        next: (response: any) => {
          if (response?.statuscode == 1) {
            this.loading = false;
            this.notification.success('Subscribed successfully');
          } else {
            this.loading = false;
            this.notification.error('Failed to subscribe');
          }
        },
        error: (error) => {
          this.loading = false;
          this.notification.error('Failed to subscribe');
        },
      });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getYear() {
    return new Date().getFullYear();
  }

  isHomePage(): boolean {
    return this.router.url.startsWith('/flight') || this.router.url === '/';
  }

  getLogoData() {
    this.dbService.getData('tokenData').then((data) => {
      if (data) {
        this.agencyLogoUrl = this.api.agencyLogoUrl + data?.AgencyLogo;
      }
    });
  }
}
